import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { marked } from 'marked';
import { CoacheeService } from 'src/app/core/services/coachee_services/coachee.service';
@Component({
  selector: 'app-coachee-ai-agreement',
  templateUrl: './coachee-ai-agreement.component.html',
})
export class CoacheeAiAgreementComponent implements OnInit {

  consentHtml: string
  
  constructor(
    private coacheeService: CoacheeService,
    private route: ActivatedRoute
  ) { }

  ngOnInit(): void {
    
    this.route.queryParams.subscribe((params) => {
      let lang = params['lang'] == 'de' ? 'de' : 'en';
      this.coacheeService.getActiveConsent('coachee-ai-usage').subscribe((res) => {
        const text = res.text.find(text => text.locale === lang).text;
        this.consentHtml = marked.parse(text) as string;
      });
    });
  }
}
